import React from 'react'
import './Hero.css'

const Hero = () => {
  
  return (
    <div className="hero_section " id='about'>
       <h2 className='hero_head'> Welcome</h2>
       <h1 className='name'>I'm Sakshi Gaikwad  <br /><span className='role'>UI-UX Designer</span>  <br />Based in Nagpur.</h1>
       <a href="cv/resume.pdf" target='_blank'><button className='main-btn'>Download CV</button></a>
       
    
    
       
       
    </div>
  )
}

export default Hero